import type { FleetTripPurpose } from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import { FLEET_TRIP_PURPOSE_LABELS } from '@/products/fleet/features/fleet-labels';

export function FleetTripPurposeBadge({ purpose }: { purpose: FleetTripPurpose }) {
  return <Badge variant="outline">{FLEET_TRIP_PURPOSE_LABELS[purpose]}</Badge>;
}
